const getDefaultState = () => {
    return {
        PersonalInformation : {
            IsDependents :false,
            Salutation : '',
            FullName : '',
            //'Mohan Daramakoday',
            tempIC:'',
            NRIC :'', 
            //'910328106187',
            OldID : '',
            EPFNumber: '',
            //'123456',
            IdType : '',
            DateOfBirth : '',
            Age : '',
            Race : '',
            RaceOth : '',
            CountryOfBirth : '',
            Nationality : '',
            Gender : 'F',
            //Gender : "",
            HolderStatus : '',
            EPFAccount:'',
            //'Conventional',
            EPFAccountType : '',
            //'Conventional',
            ShariahEPFAccount:'',
            MaritalStatus : '',
            SourceOfWealth:[],
            InvestmentPurpose:[],
            InvestmentPurposeNames : '',
            MonthlyHouseholdIncome:0,
        },
        AddressInformation : {
            PermanentAddress : {
                Address1 : '',
                Address2 : '',
                Address3 : '',

                Address_1 : '',
                Address_2 : '',
                Address_3 : '',

                TownCity:'',

                City : '',
                State : '',
                Country : '',
                StateForeign : '',
                Postcode : ''
            },
            SamePermanentAddress : true,
            CorrespondenceAddress : {
                Address1 : '',
                Address2 : '',
                Address3 : '',
                Address_1 : '',
                Address_2 : '',
                Address_3 : '',
                
                TownCity:'',

                City : '',
                State : '',
                Country : '',
                StateForeign : '',
                Postcode : ''
            }
        },
        ContactInformation : {
            MobileNo : '',
            MobilePrefix : "",
            EmailAddress : '',
            MobileNoCode: '',
        },
        EmploymentInformation : {
            EmploymentStatus : '',
            EmploymentStatusOth : '',
            BusinessNature : '',
            BusinessNatureOth : '',
            Designation : '',
            EmployerName : '',
            EmployerAddress : {
                Address1 : '',
                Address2 : '',
                Address3 : '',
                City : '',
                State : '',
                Country : '',
                StateForeign : '',
                Postcode : ''
            }
        },
        FATCAInformation : {
            NetpersonalAsset : false,
            PEP : false,
            SophisticatedInvestor:false,
            PEPPosition : '',
            PEPFamilyRelationship : '',
            TaxResidency : '',
            TINInformation : [],
            USResident : '',
            USResidentIndicia : []

        },
        Transaction:{
            Investment : []
        },
        onboardMessage:'',
        OnboardFundJson:'',
        ApplicationId : '',
        OnboardingAppID : '',
        loginUserName:'',
        loginPassWord:'',
        hideCorrespondenceAdd:false,
        requestedTac: false,
        userID:'',
        ResetPasswordUsername : false,
        ResetGroup: 'useridOnly',
        ResetOptions: [
            { label: 'User ID only', value: 'useridOnly' },
            { label: 'User ID and Password', value: 'useridAndPassword', color: 'red' }
        ],
        ResetUsername:'',
        ResetPassword:'',

        OnboardId:'',
        OnboardChannel:'',
        OnboardApplicationFormID:'',
        OnboardStatus:'',
        OnboardSalutation:'',
        OnboardCustomerName:'',
        OnboardIdType:'',
        OnboardIC:'',
        OnboardOldId:'',
        OnboardGender:'',
        OnboardDOB:'',
        OnboardNationality:'',
        OnboardCountryofBirth:'',
        OnboardRace:'',
        OnboardRaceOth:'',
        OnboardHolderStatus:'',
        OnboardMobileCountryCode:'',
        OnboardMobile:'',
        Onboardemail:'',
        OnboardPermanentAddrLine1:'',
        OnboardPermanentAddrLine2:'',
        OnboardPermanentAddrLine3:'',
        OnboardPermanentAddrCity:'',
        OnboardPermanentAddrCountry:'',
        OnboardPermanentAddrPostCode:'',
        OnboardPermanentAddrState:'',
        OnboardCorrespondenceAddrLine1:'',
        OnboardCorrespondenceAddrLine2:'',
        OnboardCorrespondenceAddrLine3:'',
        OnboardCorrespondenceAddrCity:'',
        OnboardCorrespondenceAddrPostCode:'',
        OnboardEmployemntStatus:'',
        OnboardNatureOfBusiness:'',
        OnboardNatureofBusinessOth:'',
        OnboardDesignation:'',
        OnboardEmployerName:'',
        OnboardEmployerAddressLine1:'',
        OnboardNetPersonalAsset:'',
        OnboardInvestmentPurpose:[],
        OnboardInvestmentPurposeOther:'',
        OnboardSourceOfWealth:[],
        OnboardSourceOfWealthOther:'',
        OnboardNoOfDependents:'',
        OnboardisSophisticatedInvestor:'',
        OnboardPEP:'',
        OnboardPEPPosition:'',
        OnboardPEPRelationShip:'',
        OnboardPEPFamilyRelationShip:'',
        OnboardUSResidentStatus:'',
        OnboardTaxResidency:'',
        OnboardEPFNO:'',
        OnboardAccountType:'',
        OnboardEPFEffectiveDate:'',
        OnboardAge:'',
        OnboardMaritalStatus:'',
        OnboardUserId:'',
        OnBoardUTAccountNo:'',
        LandingPageTimer:30,
        InitTime :30,
        OnboardAddressPopulate:[],
    }
}

const state = getDefaultState()

const getters = {

}

const actions = {
     
}


const mutations = {
    ResetAODetails (state) {
        Object.assign(state, getDefaultState())
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}